import { competitionLevel } from 'constants/competitionLevel';

const { YOUTH, DYYTH, DYJR } = competitionLevel;

export const isYouthCompetitionLevel = (level) =>
  [YOUTH, DYJR.value, DYYTH.value].includes(level);
